import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  container: {
    alignSelf: 'center',
    gap: spacing.xxs / 2,
  },
}));
